<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_2535_3430" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
      <rect width="20" height="20" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_2535_3430)">
      <path d="M8.19355 14.0972L8.2289 14.1328L8.26436 14.0973L15.3274 7.03535L15.3624 7.00033L15.3277 6.96497L14.2857 5.90297L14.2504 5.867L14.2147 5.90257L8.22893 11.8675L5.78522 9.44349L5.74986 9.40842L5.71465 9.44363L4.67265 10.4856L4.6374 10.5209L4.67255 10.5562L8.19355 14.0972Z"
            :fill="color" :stroke="color" stroke-width="0.1"/>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#53CBC0',
    },
  },
};
</script>
